import { OwnerAvatar } from '@playbooks/components/owner/owner-avatar';
import { Badge } from '@playbooks/ui/components/badge';
import { Link } from '@playbooks/ui/components/link';
import { formatDate } from '@playbooks/utils';

const TemplateMarketplaceDetails = ({ template, sidebar = false }) => {
	const services = template.deploy?.config?.services || [];
	const connectors = template.project?.connectors || [];
	const facts = [
		['Release', template.deploy?.currentRelease?.uuid],
		['Updated', template.updatedAt ? formatDate(template.updatedAt, 'MMM D, YYYY') : null],
		['Published', template.publishDate ? formatDate(template.publishDate, 'MMM D, YYYY') : null],
		['License', template.license?.name],
	];

	return (
		<div className={sidebar ? 'flex flex-col gap-5' : 'grid gap-6 lg:grid-cols-[minmax(0,1fr)_16rem]'}>
			<div className='flex flex-col gap-5'>
				<section>
					<h2 className='type-heading mb-2'>About</h2>
					<p className='text-sm leading-6 text-foreground-body'>
						{template.description || template.tagline || 'No description provided.'}
					</p>
				</section>
				{template.categories?.length ? (
					<section>
						<h2 className='type-pretitle mb-2'>Tags</h2>
						<div className='flex flex-wrap gap-2'>
							{template.categories.map(category => (
								<Badge key={category.id} variant='outline'>
									{category.name}
								</Badge>
							))}
						</div>
					</section>
				) : null}
				{services.length ? (
					<section>
						<h2 className='type-heading mb-2'>Stack</h2>
						<div className='flex flex-wrap gap-2'>
							{services.map(service => (
								<Badge key={service.id} variant='outline'>
									{service.key || service.category}
								</Badge>
							))}
						</div>
					</section>
				) : null}
				{connectors.length ? (
					<section>
						<h2 className='type-heading mb-2'>Connectors</h2>
						<div className='flex flex-wrap gap-2'>
							{connectors.map(item => (
								<Badge key={item.id} variant='outline'>
									{item.connector?.provider?.name || item.connector?.name}
								</Badge>
							))}
						</div>
					</section>
				) : null}
			</div>
			<aside className='rounded-panel border border-border bg-surface p-3'>
				<OwnerAvatar layout='section' owner={template.owner || {}} href={template.owner?.appPath || ''} />
				{template.owner?.appPath ? (
					<Link variant='outline' size='sm' href={template.owner.appPath} className='mt-3 w-full'>
						View profile
					</Link>
				) : null}
				<dl className='mt-4 flex flex-col gap-2 border-t pt-3 text-xs'>
					{facts.map(([label, value]) => (
						<div key={label} className='flex justify-between gap-3'>
							<dt className='text-foreground-subtle'>{label}</dt>
							<dd className='text-right'>{value || '--'}</dd>
						</div>
					))}
				</dl>
				<p className='mt-4 border-t pt-3 text-xs text-foreground-subtle'>
					Free to remix. Creator attribution remains with every remixed project.
				</p>
			</aside>
		</div>
	);
};

export { TemplateMarketplaceDetails };
